/* eslint-disable */
import React from 'react';
import { MaskOptions } from '@lmig/lmds-react-alphanumeric-input';
import { AlphanumericInput } from '@lmig/lmds-react-alphanumeric-input';
import { Popover } from '@lmig/lmds-react-popover';
import { Checkbox, CheckboxGroup } from '@lmig/lmds-react-checkbox';
import { SelectButton } from '@lmig/lmds-react-select';
import { Table } from '@tanstack/react-table';

// custom function to filter multiple values on the subject
export function multiSubjectFilter(
    row: { original: { [x: string]: any } },
    columnID: string | number,
    filterValue: string | any[]
) {
    // this will check if the value in the row can be displayed based on our custom filters we set
    return (
        filterValue.includes(row.original[columnID]) || filterValue.length < 1
    );
}

interface TextFilterFieldProps {
    column: any;
    table: Table<IPortalUser>;
    mask?: MaskOptions;
    customFilterChoices?: Array<string>;
}

// a generic component to filter columns by an input field
export function DefaultTextFilterField({
    column,
    table,
    mask,
}: TextFilterFieldProps) {
    const { getFilterValue, setFilterValue, columnDef } = column;
    const filterValue = getFilterValue();
    const handleChange = (e: any) => {
        const { value } = e.target;
        setFilterValue(value || undefined);
    };
    const [row] = table.getRowModel().rows;
    const exampleValue = row?.getValue(column.id) || '';
    const placeholder = exampleValue ? `e.g., ${exampleValue}` : '';
    return (
        <AlphanumericInput
            mask={mask as any}
            labelVisual={`Filter ${columnDef.header.toLowerCase()}`}
            placeholder={placeholder}
            value={filterValue || ''}
            onChange={handleChange}
        />
    );
}

// a generic component to filter columns with a dropdown
export function DefaultDropdownFilterField({
    column,
    customFilterChoices,
}: TextFilterFieldProps) {
    const {
        getFilterValue,
        setFilterValue,
        columnDef,
        getFacetedUniqueValues,
    } = column;
    const filterValues = getFilterValue() || [];
    const [key, setKey] = React.useState(0);
    
    const handleChange = (e: any) => {
        const { value, checked } = e.target;
        if (checked && !filterValues.includes(value)) {
            setFilterValue([...filterValues, value]);
        }
        if (!checked) {
            setFilterValue(filterValues.filter((val: any) => val !== value));
        }
        // Force popover to close by remounting it
        setTimeout(() => setKey(k => k + 1), 100);
    };

    // Use custom choices if provided, otherwise try to get from faceted values
    let choices: any[] = [];
    if (customFilterChoices && customFilterChoices.length > 0) {
        choices = customFilterChoices;
    } else {
        const uniqueValues = getFacetedUniqueValues?.();
        choices = uniqueValues ? Array.from(uniqueValues.keys()) : [];
    }

    return (
        <Popover
            key={key}
            variant="custom"
            direction="below"
            align="end"
            arrow={false}
            trigger={
                <SelectButton labelVisual={`Filter ${columnDef.header.toLowerCase()}`}>
                    {filterValues.join(', ')}
                </SelectButton>
            }
        >
            <CheckboxGroup
                onChange={handleChange}
            >
                {choices.map((choice: any) => (
                    <Checkbox
                        key={choice}
                        labelVisual={choice}
                        value={choice}
                        checked={filterValues.includes(choice)}
                    />
                ))}
            </CheckboxGroup>
        </Popover>
    );
}